import { Box, easeOutQuad, isSsr, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { clampedInversedLerp, lerp } from '@lemonade-hq/ts-helpers';
import styled from 'styled-components';

const Container = styled(Box)`
  position: relative;
`;

const TreeTop = styled(Box)`
  background-color: ${themedColor('glass')};
  border-radius: 100%;
  position: absolute;
  z-index: 0;
`;

const StallTreeTop = styled(TreeTop)`
  opacity: 0.2;
  background-color: ${themedColor('primary')};
`;

const SpecialTreeSVG = styled.svg`
  ${MEDIA_QUERIES.upToDesktop`
        width: 26%;
    `}
`;

export default function Giveback2020Trees({ t, ...props }) {
  const style = {
    transform: `scale(${lerp(0, 1, easeOutQuad(clampedInversedLerp(0.0, 0.7, t)))})`,
  };
  const delayedStyle = {
    transform: `scale(${lerp(0, 1, easeOutQuad(clampedInversedLerp(0.15, 0.85, t)))})`,
  };

  // added ssr check since it doesn't render the SVG if the user refreshes in mid-scroll in this particular component
  return (
    <Container {...props}>
      {!isSsr() && (
        <>
          <TreeTop
            width={[115, 115, 190]}
            height={[115, 115, 190]}
            top={[10, 10, 130]}
            left={[-31, -31, '4px']}
            style={delayedStyle}
          />
          <TreeTop
            width={[85, 85, 130]}
            height={[85, 85, 130]}
            top={[45, 45, 187]}
            left={[143, 143, 286]}
            style={style}
          />
          {t === 1 && (
            <StallTreeTop width={[130, 130, 250]} height={[130, 130, 250]} top={[-59, -59, -9]} left={[43, 43, 104]} />
          )}
          <Box position="absolute" bottom={[0, 0, 0]} left={0} right={0} zIndex="0">
            <svg
              style={{ width: '100%' }}
              width="326px"
              height="159px"
              viewBox="0 0 326 159"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-1235.000000, -3179.000000)" fill="#F7F7F7">
                  <g transform="translate(1235.000000, 3179.000000)">
                    <path d="M46.5365035,56.200165 L80.4669958,22.0432116 C82.5110014,19.9855638 82.5110014,16.6458431 80.4669958,14.5829193 C78.4177492,12.5252715 75.100171,12.5252715 73.0561654,14.5829193 L46.5365035,41.2795805 L46.5365035,5.27602 C46.5365035,2.35838094 44.1885176,0 41.2954636,0 C38.4024096,0 36.0544237,2.35838094 36.0544237,5.27602 L36.0544237,77.3728333 L8.94776537,50.0852579 C6.89851877,48.022334 3.58094051,48.022334 1.53693495,50.0852579 C-0.51231165,52.1429057 -0.51231165,55.4826263 1.53693495,57.5455501 L36.0544237,92.2934179 L36.0544237,154.535156 C38.3422285,156.952998 40.0892418,158.16192 41.2954636,158.16192 C42.5016854,158.16192 44.2486987,156.952998 46.5365035,154.535156 L46.5365035,56.200165 Z" />
                    <path d="M297.339529,76.4932561 L324.564364,48.8436748 C326.204414,47.1780374 326.204414,44.4745797 324.564364,42.8046714 C322.920108,41.139034 320.258181,41.139034 318.61813,42.8046714 L297.339529,64.4152493 L297.339529,35.2708652 C297.339529,32.9090767 295.455574,31 293.134272,31 C290.81297,31 288.929015,32.9090767 288.929015,35.2708652 L288.929015,93.6322382 L267.179425,71.5433234 C265.53517,69.8734151 262.873242,69.8734151 261.233192,71.5433234 C259.588936,73.2089608 259.588936,75.9124185 261.233192,77.5823268 L288.929015,105.710245 L288.929015,156 L293.048828,158 L297.339529,156 L297.339529,76.4932561 Z" />
                  </g>
                </g>
              </g>
            </svg>
          </Box>
          <Box position="absolute" bottom={['-26px', '-26px', '-4px']} left={[9, 9, 65]} zIndex="1">
            <SpecialTreeSVG
              width="326px"
              height="252px"
              viewBox="0 0 84 252"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-1370.000000, -2790.000000)" fill="#f0f0f0" opacity="0.5">
                  <g transform="translate(1235.000000, 2790.000000)">
                    <path d="M182.668297,56.9704004 L217.423997,22.3453185 C219.517714,20.2594702 219.517714,16.873978 217.423997,14.7827813 C215.324912,12.696933 211.926648,12.696933 209.832931,14.7827813 L182.668297,41.845326 L182.668297,5.34832899 C182.668297,2.39070306 180.263206,0 177.299792,0 C174.336377,0 171.931287,2.39070306 171.931287,5.34832899 L171.931287,78.4332447 L144.16538,50.7716871 C142.066294,48.6804905 138.668031,48.6804905 136.574314,50.7716871 C134.475229,52.8575354 134.475229,56.2430277 136.574314,58.3342243 L171.931287,93.558319 L171.931287,249 C174.064093,251 175.752712,252 176.997142,252 C178.241573,252 180.131958,251 182.668297,249 L182.668297,56.9704004 Z" />
                  </g>
                </g>
              </g>
            </SpecialTreeSVG>
          </Box>
        </>
      )}
    </Container>
  );
}
